import { Divider, Typography } from '@material-ui/core';
import React from 'react';

import {
  IParam,
  NETWORK_LIVE_PARAMS,
  NETWORK_LIVE_PARAMS_REQUIRED_TYPE,
  NETWORK_NOT_EDITABLE_TYPE,
  NETWORK_VOD_PARAMS,
  NETWORK_VOD_PARAMS_REQUIRED_ABDREAK_TYPE,
  NETWORK_VOD_PARAMS_REQUIRED_TYPE,
  NetworkStreamType,
} from '~/src/dash/api/network';
import { EndpointBuilderV2 } from '~/src/dash/components/endpoint-builder';
import { ModelPrimaryContainerV2 } from '~/src/dash/components/model-grid-container-v2';
import { StitchedURL } from '~/src/dash/components/stitched-url';
import { IWizardStepProps } from '~/src/dash/components/wizard';
import WizardButtons from '~/src/dash/components/wizard-buttons';
import {
  displayDependencies,
  multiSelectDependencies,
  NetworkQueryParamGroups,
  selectDependencies,
} from '~/src/dash/endpoint-builder-configs/network-query-params';

interface IStreamUrlFormProps extends IWizardStepProps {
  isUpdating: boolean;
  stitchedURL: string;
  canEdit: () => boolean;
  streamLiveParams: IParam[];
  StreamType: NetworkStreamType;
  includeWizardButtons: boolean;
  handleSaveEndpoint: (params: IParam[]) => void;
  onEndpointBuilderChange: (endpointURLParams: string) => void;
}

const StreamURLForm = ({
  onNext,
  onBack,
  canEdit,
  isUpdating,
  StreamType,
  stitchedURL,
  streamLiveParams,
  handleSaveEndpoint,
  includeWizardButtons,
  onEndpointBuilderChange,
}: IStreamUrlFormProps) => {
  let requiredParams: string[] = [];
  // Switch determines which param buttons should appear based on the stream type
  switch (StreamType) {
    case NetworkStreamType.TYPE_LIVE:
      requiredParams = Object.keys({
        ...NETWORK_LIVE_PARAMS_REQUIRED_TYPE,
        ...NETWORK_LIVE_PARAMS,
      }).map((value: string) => {
        return value;
      });
      break;
    case NetworkStreamType.TYPE_VOD:
      requiredParams = Object.keys({
        ...NETWORK_VOD_PARAMS_REQUIRED_ABDREAK_TYPE,
        ...NETWORK_VOD_PARAMS_REQUIRED_TYPE,
        ...NETWORK_VOD_PARAMS,
      }).map((value: string) => {
        return value;
      });
      break;
  }
  const notEditableParams = Object.keys({
    ...NETWORK_NOT_EDITABLE_TYPE,
  }).map((value: string) => {
    return value;
  });

  return (
    <>
      <Typography
        style={{
          paddingLeft: '5px',
          marginTop: '0px',
          marginBottom: '1px',
          fontSize: '16px',
          fontWeight: 600,
        }}
      >
        What data should advertisers receive? Build a content stream URL
      </Typography>
      <Typography
        style={{
          fontSize: '14px',
          paddingLeft: '5px',
          marginTop: '0px',
          marginBottom: '1.5rem',
          color: '#757575',
        }}
      >
        Select parameters to append to your content stream URL. The more you add, the better your
        inventory is described to advertisers.
      </Typography>

      <ModelPrimaryContainerV2
        style={{
          width: '80%',
        }}
      >
        <EndpointBuilderV2
          paramGroups={NetworkQueryParamGroups}
          endpointParamsList={streamLiveParams}
          onEndpointParamsListChange={onEndpointBuilderChange}
          displayDependencies={displayDependencies}
          selectDependencies={selectDependencies}
          multiSelectDependencies={multiSelectDependencies}
        />
        <Divider />
        <StitchedURL
          stitchedURL={stitchedURL}
          currentParams={streamLiveParams}
          requiredParams={requiredParams}
          notEditableParams={notEditableParams}
          isUpdating={isUpdating}
          canEdit={canEdit()}
          handleSave={handleSaveEndpoint}
        />
      </ModelPrimaryContainerV2>
      {includeWizardButtons && <WizardButtons onNext={onNext} onBack={onBack} />}
    </>
  );
};

export default StreamURLForm;
